// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live-chat-parent-container {
  width: 100%;
  max-width: 1100px;
}

.live-chat-status-desc-fade {
  animation: liveChatStatusDescFade 0.35s ease;
}

@keyframes liveChatStatusDescFade {
  from {
    opacity: 0;
    transform: translateY(-3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.live-chat-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
}

.live-chat-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 20px;
  line-height: 1.45;
  border-left: 5px solid #5616ea;
}

.widget-sub-header {
    margin-bottom: 10px;
    border-bottom: none;
    padding-bottom: 0;
}

.live-chat-info-icon {
  font-size: 32px;
  color: #5616ea;
  flex-shrink: 0;
}

.live-chat-info-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.live-chat-info-content p {
  margin: 0;
}

/* Availability Mode */
.availability-mode-selector {
  display: flex;
  gap: 12px;
}

.availability-mode-card {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 12px;
  background-color: #fafafa;
  cursor: pointer;
  transition: border-color 0.3s ease, background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}

.availability-mode-card:hover {
  border-color: #b39ddb;
  background-color: #f5f0ff;
  transform: translateY(-1px);
}

.availability-mode-card.selected {
  border-color: #5616ea;
  background-color: #f3eaff;
}

.availability-mode-card-disabled {
  opacity: 0.55;
  cursor: not-allowed;
  background-color: #fafafa;
}

.availability-mode-card-disabled:hover {
  border-color: #e0e0e0;
  background-color: #fafafa;
  transform: none;
}

.availability-mode-card-badge {
  margin-left: auto;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #ede7f6;
  color: #5616ea;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.availability-mode-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.availability-mode-card-icon {
  font-size: 20px;
  color: #5616ea;
}

.availability-mode-card-title {
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.availability-mode-card-description {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

/* Schedule Grid */
.schedule-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.schedule-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 16px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.schedule-day-label {
  width: 100px;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  flex-shrink: 0;
}

.schedule-times {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.schedule-times .MuiTextField-root {
  max-width: 130px;
}

.schedule-time-dropdown {
  display: flex;
  align-items: center;
  gap: 2px;
}

.time-select {
  appearance: none;
  -webkit-appearance: none;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 14px;
  font-family: inherit;
  color: #333;
  cursor: pointer;
  min-width: 52px;
  text-align: center;
  outline: none;
  transition: border-color 0.3s ease;
}

.time-select:focus {
  border-color: #5616ea;
}

.time-select:hover {
  border-color: #b39ddb;
}

.time-colon {
  font-size: 16px;
  font-weight: 600;
  color: #666;
  padding: 0 1px;
}

.schedule-timezone-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding: 10px 14px;
  background-color: #f5f0ff;
  border: 1px solid #e0d4f5;
  border-radius: 8px;
}

.schedule-timezone-icon {
  color: #5616ea;
  font-size: 14px;
  flex-shrink: 0;
}

.schedule-timezone-link {
  color: #5616ea;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin-left: auto;
  white-space: nowrap;
  transition: color 0.3s ease;
}

.schedule-timezone-link:hover {
  color: #4a14d6;
}

.schedule-separator {
  font-size: 14px;
  color: #999;
}

.schedule-row-disabled {
  opacity: 0.45;
}

.schedule-row-disabled .schedule-times {
  pointer-events: none;
}

/* Notifications matrix */
.live-notify-subtitle {
  margin: 0 0 12px 0;
  font-size: 13px;
  color: #666;
}

.live-notify-presets {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}

.live-notify-presets-label {
  font-size: 13px;
  color: #555;
  margin-right: 4px;
}

.live-notify-preset-chip {
  appearance: none;
  border: 1px solid #e0d4f5;
  background-color: #fff;
  color: #5616ea;
  font-weight: 500;
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color 0.5s ease, border-color 0.3s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}

.live-notify-preset-chip:hover {
  background-color: #f5f0ff;
  transform: translateY(-1px);
}

.live-notify-preset-chip.active {
  background-color: #5616ea;
  border-color: #5616ea;
  color: #fff;
}

.live-notify-matrix {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  margin-bottom: 0;
}

.live-notify-matrix-row {
  display: grid;
  grid-template-columns: minmax(0, 2fr) repeat(5, minmax(0, 0.55fr));
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid #f0f0f0;
  gap: 4px;
}

.live-notify-matrix-row:last-child {
  border-bottom: none;
}

.live-notify-matrix-header {
  background-color: #f5f5f5;
  padding: 8px 14px;
}

.live-notify-matrix-row-highlight {
  background-color: transparent;
}

.live-notify-matrix-event-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.live-notify-matrix-event-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.live-notify-matrix-event-icon {
  color: #5616ea;
  font-size: 14px;
}

.live-notify-matrix-event-desc {
  font-size: 12px;
  color: #777;
  line-height: 1.4;
  padding-left: 22px;
  margin-top: 3px;
}

.live-notify-matrix-channel-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  text-align: center;
  min-width: 0;
}

.live-notify-matrix-channel-icon {
  color: #5616ea;
  font-size: 16px;
}

.live-notify-matrix-channel-icon-brand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.live-notify-matrix-channel-icon-brand svg {
  display: block;
}

.live-notify-matrix-channel-label-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-wrap: nowrap;
  white-space: nowrap;
  max-width: 100%;
  min-width: 0;
}

.live-notify-matrix-channel-label {
  font-size: 11px;
  font-weight: 500;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.live-notify-matrix-coming-soon {
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #6b6b78;
  background-color: #e4e4ec;
  padding: 1px 5px;
  border-radius: 999px;
  line-height: 1.4;
}

@media (max-width: 600px) {
  .live-notify-matrix-row {
    grid-template-columns: minmax(0, 1.6fr) repeat(5, minmax(0, 0.5fr));
    padding: 10px 6px;
    gap: 2px;
  }
  .live-notify-matrix-event-desc {
    display: none;
  }
  .live-notify-matrix-channel-label {
    font-size: 10px;
  }
}

/* Notification email field */
.live-chat-email-receiver {
  max-width: 400px;
  margin-bottom: 10px !important;
}

/* Timeout / Numeric Inputs */
.live-chat-numeric-setting {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 6px;
  padding-bottom: 0;
}

.live-chat-numeric-label {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
}

.live-chat-numeric-label-title {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.live-chat-numeric-label-description {
  font-size: 13px;
  color: #888;
  line-height: 1.4;
}

.live-chat-numeric-input {
  max-width: 120px !important;
}

/* Offline message textarea */
.live-chat-offline-message {
  margin-top: 8px;
}

/* Agent Avatar */
.agent-avatar-selector {
  margin-bottom: 4px;
}

.agent-avatar-options {
  display: flex;
  gap: 10px;
  align-items: center;
}

.agent-avatar-option {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease, background-color 0.5s ease;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  will-change: transform;
  backface-visibility: hidden;
}

.agent-avatar-option:hover {
  transform: scale(1.08);
}

.agent-avatar-upload-btn {
  background-color: #d5d5d5;
  color: #666;
  font-size: 18px;
}

.agent-avatar-upload-btn:hover {
  background-color: #c5c5c5;
}

.agent-avatar-custom img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 50%;
}

.agent-avatar-checkmark {
  position: absolute;
  top: -5px;
  left: -5px;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5616ea;
  font-size: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

.agent-avatar-checkmark .checkmark-icon,
.agent-avatar-checkmark .xmark-icon {
  position: absolute;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.agent-avatar-checkmark .checkmark-icon {
  opacity: 1;
  transform: scale(1);
}

.agent-avatar-checkmark .xmark-icon {
  opacity: 0;
  transform: scale(0.5);
}

.agent-avatar-option.selected:hover .agent-avatar-checkmark .checkmark-icon {
  opacity: 0;
  transform: scale(0.5);
}

.agent-avatar-option.selected:hover .agent-avatar-checkmark .xmark-icon {
  opacity: 1;
  transform: scale(1);
}

.agent-avatar-color-picker {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}

.agent-avatar-color-picker label {
  font-size: 14px;
  font-weight: 500;
  color: #444;
}

.agent-avatar-color-picker input[type="color"] {
  border: 1px solid rgb(199, 199, 199);
  width: 34px;
  height: 34px;
  cursor: pointer;
  border-radius: 20%;
  padding: 1.5px;
  background: none;
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  outline: none;
  will-change: transform;
  backface-visibility: hidden;
}

.agent-avatar-color-picker input[type="color"]:hover {
  transform: scale(1.1);
}

.agent-avatar-color-picker input[type="color"]::-webkit-color-swatch {
  border: none;
  border-radius: 20%;
}

.live-chat-container input[type="file"] {
  display: none;
}

.live-chat-container label.file-upload {
  width: 200px;
  display: inline-block;
  padding: 10px 15px;
  border-radius: 5px;
  border: 1px solid #ddd;
  cursor: pointer;
  background-color: #ededed;
  text-align: center;
  transition: background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;
  backface-visibility: hidden;
}

.live-chat-container label.file-upload:hover {
  background-color: #dedede;
  transform: translateY(-2px);
}

.live-chat-container .upload-icon-text {
  display: flex;
  align-items: center;
  gap: 10px;
}

.live-chat-container .upload-icon-text p {
  margin: 0;
  padding: 0;
}

.live-chat-container .upload-with-tooltip {
  display: flex;
  align-items: center;
  gap: 4px;
}

.live-chat-container .uploaded-file-info {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.live-chat-container .uploaded-file-info span {
  margin-right: 8px;
  font-size: 14px;
  color: #333;
}

.live-chat-container .remove-file-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #d9534f;
  font-size: 16px;
  transition: color 0.3s ease;
}

.live-chat-container .remove-file-btn:hover {
  color: #c9302c;
}

/* Responsive */
@media (max-width: 768px) {
  .availability-mode-selector {
    flex-direction: column;
  }

  .schedule-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .schedule-day-label {
    width: auto;
  }

  .live-chat-numeric-setting {
    flex-direction: column;
    align-items: flex-start;
  }

  .live-chat-numeric-input {
    max-width: 100% !important;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/liveChatSettings.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,oHAAoH;EACpH,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,qIAAqI;EACrI,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE;IACE,mEAAmE;IACnE,iBAAiB;IACjB,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,+GAA+G;EAC/G,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;;EAEE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gEAAgE;EAChE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,4FAA4F;EAC5F,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF","sourcesContent":[".live-chat-parent-container {\r\n  width: 100%;\r\n  max-width: 1100px;\r\n}\r\n\r\n.live-chat-status-desc-fade {\r\n  animation: liveChatStatusDescFade 0.35s ease;\r\n}\r\n\r\n@keyframes liveChatStatusDescFade {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-3px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.live-chat-container {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n}\r\n\r\n.live-chat-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  margin-bottom: 20px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #5616ea;\r\n}\r\n\r\n.widget-sub-header {\r\n    margin-bottom: 10px;\r\n    border-bottom: none;\r\n    padding-bottom: 0;\r\n}\r\n\r\n.live-chat-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.live-chat-info-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.live-chat-info-content p {\r\n  margin: 0;\r\n}\r\n\r\n/* Availability Mode */\r\n.availability-mode-selector {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.availability-mode-card {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding: 16px;\r\n  border: 1px solid rgba(0, 0, 0, 0.23);\r\n  border-radius: 12px;\r\n  background-color: #fafafa;\r\n  cursor: pointer;\r\n  transition: border-color 0.3s ease, background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.availability-mode-card:hover {\r\n  border-color: #b39ddb;\r\n  background-color: #f5f0ff;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.availability-mode-card.selected {\r\n  border-color: #5616ea;\r\n  background-color: #f3eaff;\r\n}\r\n\r\n.availability-mode-card-disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.availability-mode-card-disabled:hover {\r\n  border-color: #e0e0e0;\r\n  background-color: #fafafa;\r\n  transform: none;\r\n}\r\n\r\n.availability-mode-card-badge {\r\n  margin-left: auto;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background-color: #ede7f6;\r\n  color: #5616ea;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.availability-mode-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.availability-mode-card-icon {\r\n  font-size: 20px;\r\n  color: #5616ea;\r\n}\r\n\r\n.availability-mode-card-title {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.availability-mode-card-description {\r\n  font-size: 13px;\r\n  color: #666;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* Schedule Grid */\r\n.schedule-grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin-top: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.schedule-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 6px 16px;\r\n  background-color: #fafafa;\r\n  border: 1px solid #e8e8e8;\r\n  border-radius: 8px;\r\n}\r\n\r\n.schedule-day-label {\r\n  width: 100px;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  color: #333;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.schedule-times {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex: 1;\r\n}\r\n\r\n.schedule-times .MuiTextField-root {\r\n  max-width: 130px;\r\n}\r\n\r\n.schedule-time-dropdown {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.time-select {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  background-color: #fff;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  padding: 6px 10px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  color: #333;\r\n  cursor: pointer;\r\n  min-width: 52px;\r\n  text-align: center;\r\n  outline: none;\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\n.time-select:focus {\r\n  border-color: #5616ea;\r\n}\r\n\r\n.time-select:hover {\r\n  border-color: #b39ddb;\r\n}\r\n\r\n.time-colon {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #666;\r\n  padding: 0 1px;\r\n}\r\n\r\n.schedule-timezone-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 10px;\r\n  padding: 10px 14px;\r\n  background-color: #f5f0ff;\r\n  border: 1px solid #e0d4f5;\r\n  border-radius: 8px;\r\n}\r\n\r\n.schedule-timezone-icon {\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.schedule-timezone-link {\r\n  color: #5616ea;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  margin-left: auto;\r\n  white-space: nowrap;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.schedule-timezone-link:hover {\r\n  color: #4a14d6;\r\n}\r\n\r\n.schedule-separator {\r\n  font-size: 14px;\r\n  color: #999;\r\n}\r\n\r\n.schedule-row-disabled {\r\n  opacity: 0.45;\r\n}\r\n\r\n.schedule-row-disabled .schedule-times {\r\n  pointer-events: none;\r\n}\r\n\r\n/* Notifications matrix */\r\n.live-notify-subtitle {\r\n  margin: 0 0 12px 0;\r\n  font-size: 13px;\r\n  color: #666;\r\n}\r\n\r\n.live-notify-presets {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.live-notify-presets-label {\r\n  font-size: 13px;\r\n  color: #555;\r\n  margin-right: 4px;\r\n}\r\n\r\n.live-notify-preset-chip {\r\n  appearance: none;\r\n  border: 1px solid #e0d4f5;\r\n  background-color: #fff;\r\n  color: #5616ea;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n  padding: 6px 12px;\r\n  border-radius: 999px;\r\n  cursor: pointer;\r\n  transition: background-color 0.5s ease, border-color 0.3s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.live-notify-preset-chip:hover {\r\n  background-color: #f5f0ff;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.live-notify-preset-chip.active {\r\n  background-color: #5616ea;\r\n  border-color: #5616ea;\r\n  color: #fff;\r\n}\r\n\r\n.live-notify-matrix {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid rgba(0, 0, 0, 0.23);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  background-color: #fff;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.live-notify-matrix-row {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 2fr) repeat(5, minmax(0, 0.55fr));\r\n  align-items: center;\r\n  padding: 10px 14px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  gap: 4px;\r\n}\r\n\r\n.live-notify-matrix-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.live-notify-matrix-header {\r\n  background-color: #f5f5f5;\r\n  padding: 8px 14px;\r\n}\r\n\r\n.live-notify-matrix-row-highlight {\r\n  background-color: transparent;\r\n}\r\n\r\n.live-notify-matrix-event-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.live-notify-matrix-event-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.live-notify-matrix-event-icon {\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n}\r\n\r\n.live-notify-matrix-event-desc {\r\n  font-size: 12px;\r\n  color: #777;\r\n  line-height: 1.4;\r\n  padding-left: 22px;\r\n  margin-top: 3px;\r\n}\r\n\r\n.live-notify-matrix-channel-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 3px;\r\n  text-align: center;\r\n  min-width: 0;\r\n}\r\n\r\n.live-notify-matrix-channel-icon {\r\n  color: #5616ea;\r\n  font-size: 16px;\r\n}\r\n\r\n.live-notify-matrix-channel-icon-brand {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1;\r\n}\r\n\r\n.live-notify-matrix-channel-icon-brand svg {\r\n  display: block;\r\n}\r\n\r\n.live-notify-matrix-channel-label-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  flex-wrap: nowrap;\r\n  white-space: nowrap;\r\n  max-width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.live-notify-matrix-channel-label {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  color: #555;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  min-width: 0;\r\n}\r\n\r\n.live-notify-matrix-coming-soon {\r\n  flex-shrink: 0;\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.3px;\r\n  text-transform: uppercase;\r\n  color: #6b6b78;\r\n  background-color: #e4e4ec;\r\n  padding: 1px 5px;\r\n  border-radius: 999px;\r\n  line-height: 1.4;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .live-notify-matrix-row {\r\n    grid-template-columns: minmax(0, 1.6fr) repeat(5, minmax(0, 0.5fr));\r\n    padding: 10px 6px;\r\n    gap: 2px;\r\n  }\r\n  .live-notify-matrix-event-desc {\r\n    display: none;\r\n  }\r\n  .live-notify-matrix-channel-label {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n/* Notification email field */\r\n.live-chat-email-receiver {\r\n  max-width: 400px;\r\n  margin-bottom: 10px !important;\r\n}\r\n\r\n/* Timeout / Numeric Inputs */\r\n.live-chat-numeric-setting {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding-top: 6px;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.live-chat-numeric-label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  flex: 1;\r\n}\r\n\r\n.live-chat-numeric-label-title {\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.live-chat-numeric-label-description {\r\n  font-size: 13px;\r\n  color: #888;\r\n  line-height: 1.4;\r\n}\r\n\r\n.live-chat-numeric-input {\r\n  max-width: 120px !important;\r\n}\r\n\r\n/* Offline message textarea */\r\n.live-chat-offline-message {\r\n  margin-top: 8px;\r\n}\r\n\r\n/* Agent Avatar */\r\n.agent-avatar-selector {\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.agent-avatar-options {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.agent-avatar-option {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease, background-color 0.5s ease;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #fff;\r\n  font-size: 22px;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.agent-avatar-option:hover {\r\n  transform: scale(1.08);\r\n}\r\n\r\n.agent-avatar-upload-btn {\r\n  background-color: #d5d5d5;\r\n  color: #666;\r\n  font-size: 18px;\r\n}\r\n\r\n.agent-avatar-upload-btn:hover {\r\n  background-color: #c5c5c5;\r\n}\r\n\r\n.agent-avatar-custom img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n  border-radius: 50%;\r\n}\r\n\r\n.agent-avatar-checkmark {\r\n  position: absolute;\r\n  top: -5px;\r\n  left: -5px;\r\n  width: 20px;\r\n  height: 20px;\r\n  background-color: #fff;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #5616ea;\r\n  font-size: 10px;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n.agent-avatar-checkmark .checkmark-icon,\r\n.agent-avatar-checkmark .xmark-icon {\r\n  position: absolute;\r\n  transition: opacity 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.agent-avatar-checkmark .checkmark-icon {\r\n  opacity: 1;\r\n  transform: scale(1);\r\n}\r\n\r\n.agent-avatar-checkmark .xmark-icon {\r\n  opacity: 0;\r\n  transform: scale(0.5);\r\n}\r\n\r\n.agent-avatar-option.selected:hover .agent-avatar-checkmark .checkmark-icon {\r\n  opacity: 0;\r\n  transform: scale(0.5);\r\n}\r\n\r\n.agent-avatar-option.selected:hover .agent-avatar-checkmark .xmark-icon {\r\n  opacity: 1;\r\n  transform: scale(1);\r\n}\r\n\r\n.agent-avatar-color-picker {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 14px;\r\n}\r\n\r\n.agent-avatar-color-picker label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #444;\r\n}\r\n\r\n.agent-avatar-color-picker input[type=\"color\"] {\r\n  border: 1px solid rgb(199, 199, 199);\r\n  width: 34px;\r\n  height: 34px;\r\n  cursor: pointer;\r\n  border-radius: 20%;\r\n  padding: 1.5px;\r\n  background: none;\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  outline: none;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.agent-avatar-color-picker input[type=\"color\"]:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.agent-avatar-color-picker input[type=\"color\"]::-webkit-color-swatch {\r\n  border: none;\r\n  border-radius: 20%;\r\n}\r\n\r\n.live-chat-container input[type=\"file\"] {\r\n  display: none;\r\n}\r\n\r\n.live-chat-container label.file-upload {\r\n  width: 200px;\r\n  display: inline-block;\r\n  padding: 10px 15px;\r\n  border-radius: 5px;\r\n  border: 1px solid #ddd;\r\n  cursor: pointer;\r\n  background-color: #ededed;\r\n  text-align: center;\r\n  transition: background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.live-chat-container label.file-upload:hover {\r\n  background-color: #dedede;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.live-chat-container .upload-icon-text {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.live-chat-container .upload-icon-text p {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.live-chat-container .upload-with-tooltip {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.live-chat-container .uploaded-file-info {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-top: 8px;\r\n}\r\n\r\n.live-chat-container .uploaded-file-info span {\r\n  margin-right: 8px;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.live-chat-container .remove-file-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #d9534f;\r\n  font-size: 16px;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.live-chat-container .remove-file-btn:hover {\r\n  color: #c9302c;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .availability-mode-selector {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .schedule-row {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n\r\n  .schedule-day-label {\r\n    width: auto;\r\n  }\r\n\r\n  .live-chat-numeric-setting {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .live-chat-numeric-input {\r\n    max-width: 100% !important;\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
